import { useEffect } from 'react'
import './App.css'
import BaseConverter from './components/BaseConverter'
import FloatConverter from './components/FloatConverter'

function App() {
  useEffect(() => {
    // 初始化 AdSense
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch (err) {
      console.error('AdSense error:', err)
    }
  }, [])

  return (
    <div className="page">
      <header className="header">
        <h1>在线进制转换</h1>
        <a href="https://www.findhao.net" className="blog-link" target="_blank" rel="noopener noreferrer">
          我的博客：www.findhao.net
        </a>
      </header>

      <main className="main-content">
        <BaseConverter />
        <FloatConverter />
      </main>
    </div>
  )
}

export default App
